/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonProposalVoteValidatorListRequest = {
    proposalId?: string;
    voteType?: Array<'YES' | 'NO' | 'VETO' | 'ABSTAIN' | 'DID_NOT_VOTE' | 'WEIGHTED'>;
    sortField?: BabylonProposalVoteValidatorListRequest.sortField;
    sortDirection?: BabylonProposalVoteValidatorListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonProposalVoteValidatorListRequest {

    export enum sortField {
        VOTING_POWER = 'VOTING_POWER',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

